var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBiometric = function SvgBiometric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 175,
    height: 80,
    viewBox: "0 0 175 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#ebf1ed",
    rx: 40
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 95,
    fill: "#ebf1ed",
    rx: 40
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#242226",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.466 57.02v-8.293c0-7.198-5.835-13.032-13.032-13.032-7.198 0-13.032 5.834-13.032 13.032v7.108M62.173 27.378c-5.433-6.502-13.603-10.639-22.74-10.639-8.73 0-16.577 3.777-21.998 9.786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.759 47.542c0-9.036-5.62-16.759-13.555-19.865m-7.77-1.46c-11.778 0-21.326 9.548-21.326 21.325M42.988 59.282V48.727a3.554 3.554 0 1 0-7.108 0s.195 4.667 0 6.96c-.486 5.686-3.555 8.442-3.555 8.442"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#202e53",
    d: "M155.858 50.516c.63 0 1.142.511 1.142 1.142v5.051c0 4.02-3.27 7.291-7.291 7.291h-5.05a1.142 1.142 0 0 1 0-2.284h5.05a5.013 5.013 0 0 0 5.007-5.007v-5.05c0-.632.511-1.143 1.142-1.143zm-41.716 0c.63 0 1.142.511 1.142 1.142v5.051a5.013 5.013 0 0 0 5.007 5.007h5.05a1.142 1.142 0 0 1 0 2.284h-5.05c-4.02 0-7.291-3.27-7.291-7.291v-5.05c0-.632.511-1.143 1.142-1.143zm27.408.304a1.19 1.19 0 0 1 1.655.065 1.13 1.13 0 0 1-.065 1.62c-2.126 1.92-4.89 2.979-7.785 2.979s-5.66-1.058-7.785-2.98a1.13 1.13 0 0 1-.066-1.62 1.19 1.19 0 0 1 1.656-.064c1.69 1.53 3.891 2.371 6.195 2.371s4.504-.842 6.195-2.37zm-5.558-15.207c.628 0 1.137.506 1.137 1.131v8.043a2.901 2.901 0 0 1-2.905 2.89h-.926a1.134 1.134 0 0 1-1.137-1.13c0-.625.51-1.132 1.137-1.132h.926a.63.63 0 0 0 .632-.628v-8.043c0-.625.509-1.131 1.136-1.131zm7.879 0c.588 0 1.064.506 1.064 1.131v3.415c0 .625-.476 1.131-1.064 1.131-.588 0-1.065-.506-1.065-1.13v-3.416c0-.625.477-1.131 1.065-1.131zm-17.742 0c.588 0 1.065.506 1.065 1.131v3.415c0 .583-.416 1.063-.949 1.125l-.116.006c-.588 0-1.064-.506-1.064-1.13v-3.416c0-.625.476-1.131 1.064-1.131zM125.342 20a1.142 1.142 0 0 1 0 2.284h-5.051a5.013 5.013 0 0 0-5.007 5.007v5.05a1.142 1.142 0 0 1-2.284 0v-5.05c0-4.02 3.27-7.291 7.291-7.291zm24.367 0c4.02 0 7.291 3.27 7.291 7.291v5.05a1.142 1.142 0 0 1-2.284 0v-5.05a5.013 5.013 0 0 0-5.007-5.007h-5.05a1.142 1.142 0 0 1 0-2.284z"
  }))));
};
export default SvgBiometric;